<div class="container">
  <div class="modal-content">
    <app-titulo>Venda de Estoque</app-titulo>
    <form [formGroup]="form">
      <app-input type="text" [label]="labelCliente" name="TX_CLNT" formControlName="TX_CLNT"
        [requiredInput]="clienteObrigatorio"></app-input>
      <p class="cliente-hint" *ngIf="clienteObrigatorio">
        Para pagamento a prazo, informe o nome do cliente.
      </p>

      <h3 class="full-row">Produtos</h3>
      <div formArrayName="Itens" class="itens-list">
        <div *ngFor="let item of Itens.controls; let i = index" [formGroupName]="i" class="item-row">
          <app-input type="select" label="Produto" name="FK_PROD" formControlName="FK_PROD" [selectData]="produtoOptions"
            [requiredInput]="true"></app-input>
          <app-input type="number" [label]="labelQuantidade(item)" name="QT_VEND" formControlName="QT_VEND"
            [requiredInput]="true"></app-input>
          <div class="unidade-item" *ngIf="item.get('FK_PROD')?.value">
            <span class="unidade-label">Unidade</span>
            <span class="unidade-value">{{ labelUnidadeItem(item) }}</span>
          </div>
          <app-input type="money" label="Valor Unit." name="VL_UNIT" formControlName="VL_UNIT"></app-input>
          <app-input type="money" label="Subtotal" name="VL_TOTL" formControlName="VL_TOTL" [disabled]="true"></app-input>
          <button type="button" class="action-button" *ngIf="Itens.length > 1" (click)="removeItem(i)">
            <img src="assets/delete-icon.svg" alt="Remover" />
          </button>
        </div>
      </div>
      <app-botao type="secundario" text="Adicionar Produto" (click)="addItem()"></app-botao>

      <app-input type="money" label="Acréscimo" name="VL_ACRM" formControlName="VL_ACRM"></app-input>
      <app-input type="money" label="Desconto" name="VL_DSCT" formControlName="VL_DSCT"></app-input>

      <h3>Pagamento</h3>
      <app-input type="select" label="Forma de pagamento" name="NU_TIPO_PGMT" formControlName="NU_TIPO_PGMT"
        [selectData]="modoPagamentoOptions" (ngModelChange)="onChangeModoPagamento($event)"></app-input>
      <div class="valor-input">
        <app-input type="money" label="Valor pagamento" name="VL_PGMT" formControlName="VL_PGMT"
          placeholder="Digite aqui"></app-input>
        <add-button
          *ngIf="form.controls['NU_TIPO_PGMT'].value && form.controls['VL_PGMT'].value && form.controls['VL_REST'].value > 0"
          (click)="addPagamento()"></add-button>
      </div>

      <div *ngIf="ServicoPagamentoTipoValor.length > 0" class="pagamentos-list">
        <h3>Pagamentos adicionados</h3>
        <ul>
          <li *ngFor="let pagamento of ServicoPagamentoTipoValor.controls; let i = index" class="pagamento">
            {{ pagamento.get('NM_TIPO_PGMT')?.value }} -
            {{
              pagamento.get('VL_PGMT_SAID')?.value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              })
            }}
            <button type="button" class="action-button" (click)="removePagamento(i)">
              <img src="assets/delete-icon.svg" alt="Remover" />
            </button>
          </li>
        </ul>
      </div>
    </form>
  </div>

  <div class="buttons">
    <div class="total-restante">
      <p>
        Total:
        {{
          form.controls['VL_TOTL'].value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }}
      </p>
      <p>
        Restante:
        {{
          form.controls['VL_REST'].value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }}
      </p>
    </div>
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()"></app-botao>
    <app-botao text="Confirmar Venda" [bgColor]="disableConfirmar() ? '#d1d5db' : '#059669'"
      (click)="confirmarVenda()" [disabled]="disableConfirmar()"></app-botao>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
